import React from 'react';
import PropertyOwnerBilling from '../../components/BillingManagement/PropertyOwnerBilling';
import RentalManagementCompanyBilling from '../../components/BillingManagement/RentalManagementCompanyBilling';
import { useUserRole } from '../../hooks/useUserRole';

/**
 * 빌링 관리 메인 페이지
 * 사용자 역할에 따라 다른 컴포넌트를 렌더링
 * 
 * 참고: 임대관리 서비스 수수료 청구는 PropertyOwners 페이지에서 관리합니다.
 */
const BillingManagement = () => {
  const { isRentalManagementCompany, isPropertyOwner } = useUserRole();

  // 역할별 컴포넌트 렌더링
  if (isRentalManagementCompany) {
    return <RentalManagementCompanyBilling />;
  } else if (isPropertyOwner) {
    return <PropertyOwnerBilling />;
  } else {
    return (
      <div className="space-y-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">임대료 청구관리</h1>
          <p className="text-gray-600">임대료 청구 작업 권한이 없습니다.</p>
        </div>
      </div>
    );
  }
};

export default BillingManagement;
